/* eslint-disable no-console */

import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  let refreshing = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (refreshing) return;
    refreshing = true;
    window.location.reload();
  });

  register(`${process.env.BASE_URL}service-worker.js`, {
    registered (registration) {
      setInterval(() => registration.update(), 1000 * 60 * 60);
    },
    updated (registration) {
      if (registration.waiting) {
        registration.waiting.postMessage('skipWaiting');
      }
    },
  })
}
